<template>
<div>
<el-dialog
    title="确认入库"
    :visible.sync="xcVisible"
    :close-on-click-modal="false"
    width="80%"
    center
    :before-close="closeadd"
  >
  <div class="topForm">
    <div class="top" style="font-size:16px;margin-bottom:10px;margin-left:10px;">
      车号：<span >{{chepai}}</span>
    </div>
  </div>
     <div class="bottomTable">
      <div class="detailsTitle">
        <h4>货物信息</h4>
      </div>
      <el-table min-height="300px" size="mini" border center bordersize="mini" ref="tableref" :data="table" style="width: 100%" class="elTab">
       <el-table-column prop="number" label="件数" align="center"  >
        <template slot-scope="scope1">
         <el-input v-model="scope1.row.number" maxlength="50" placeholder="请输入件数" size="mini" @input="NumberInput(scope1.row)" v-number-input.float="0"></el-input>
        </template>
       </el-table-column>
       <el-table-column prop="weight" label="理重(吨)" align="center" >
        <template slot-scope="scope1">
          <el-input v-model="scope1.row.weight" maxlength="50" placeholder="请输入理重(吨)" size="mini" :disabled="true"></el-input>
        </template>
       </el-table-column>
        <el-table-column prop="weighingWeight" label="过磅净重(吨)" align="center" >
        <template slot-scope="scope1">
          <el-input v-model="scope1.row.weighingWeight" :disabled='scope1.row.disWeighingWeight' maxlength="50" placeholder="请输入过磅净重(吨)" size="mini" v-number-input.float="4"></el-input>
        </template>
       </el-table-column>
       <el-table-column prop="warehouseId" label="仓位" align="center" >
        <template slot-scope="scope1">
         <el-select ref="selectProvinces"  @visible-change='isShowSelectOptions' filterable clearable v-model="scope1.row.warehouseId" size="mini" placeholder="请选择仓位" @change="selectCangwei(scope1.row)" >
          <el-option v-for="(item,index) in warehouseOptions" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
         </el-select>
        </template>
       </el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" ></el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" ></el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" ></el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" ></el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重(吨)" align="center" ></el-table-column>
      </el-table>
     </div>
    <div slot="footer" style="width: 310px; margin: 15px auto">
      <el-button @click="closeadd">取 消</el-button>
      <el-button type="primary" :loading="Loading" @click="addDialog(1)">确认入库</el-button>
      <el-button type="primary" :loading="LoadingB" @click="addDialog(2)">保存并打印</el-button>
    </div>
  </el-dialog>
  <el-dialog
    @close="closeDialogFile"
    title="提示"
    :visible.sync="confirmMark"
    :close-on-click-modal="false"
    width="30%"
    center
  >
    <div style="margin: 15px auto" class="el-dialog--center">
      是否确认入库
    </div>
    <div style="margin: 15px auto" class="el-dialog--center">
      <el-button @click="closeDialogFile">取消</el-button>
      <el-button type="primary" @click="confirmQueding()">确定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import {
  zidianKuwei,
  JfunloadConfirm,
  JfconfirmThreadExp,
  JfgetThreadDetailExpList
} from '@/api/wms-access'
import { getWeighingMethodList } from '@/api/wms-stock'
import { dateFormat1 } from '@/utils/util.js'
export default {
  name: 'xieCheDialog',
  data () {
    return {
      table: [],
      warehouseOptions: [],
      Loading: false,
      LoadingB: false,
      confirmMark: false,
      daYinFlag: false
    }
  },
  props: {
    xcVisible: {
      type: Boolean,
      default: false
    },
    chepai: {
      type: String,
      default: ''
    },
    instockId: {
      type: String
    },
    warehouseId: {
      type: String
    }
  },
  watch: {
  },
  methods: {
    closeDialogFile () {
      this.confirmMark = false
      this.Loading = false
      this.LoadingB = false
    },
    // 是否显示下拉框
    isShowSelectOptions (isShowSelectOptions) {
      if (!isShowSelectOptions) this.$refs.selectProvinces.blur()
    },
    closeadd () {
      this.$emit('update:xcVisible', false)
    },
    addDialog (n) {
      let guobangTime = dateFormat1(new Date().getTime(), 'YYYY-MM-ss h-m-s')
      for (let i = 0; i < this.table.length; i++) {
        this.table[i].weighingDate = guobangTime
        if (this.table[i].number == '') {
          this.$message({ message: '请填写件数', type: 'error' })
          return
        } else if (this.table[i].weighingWeight == '') {
          this.$message({ message: '请填写过磅净重', type: 'error' })
          return
        } else if (this.table[i].inWeighingMethod == '2' && this.table[i].inPoundMethod == '2') {
          this.$message({ message: '请填写过磅净重', type: 'error' })
          return
        } else if (this.table[i].warehouseId == '') {
          this.$message({ message: '请选择仓位', type: 'error' })
          return
        } else if (this.table[i].number == 0) {
          this.$message({ message: '件数不能为零', type: 'error' })
          return
        }
      }
      if (n == '1') {
        this.Loading = true
      } else {
        this.LoadingB = true
      }
      JfunloadConfirm(this.table)
        .then(res => {
          this.confirmMark = true
          if (n == '1') {
            this.daYinFlag = false
          } else {
            this.daYinFlag = true
          }
        })
        .catch(err => {
          if (n == '1') {
            this.Loading = false
          } else {
            this.LoadingB = false
          }
          this.$message({ message: err.message, type: 'error' })
        })
    },
    confirmQueding () {
      JfconfirmThreadExp({
        instockId: this.instockId
      })
        .then(res => {
          this.confirmMark = false
          if (this.daYinFlag == true) {
            this.$message({ message: '操作成功!', type: 'success' })
            this.$emit('update:xcVisible', false)
            this.LoadingB = false
            this.$router.push({
              path: '/yycRuKuDan',
              query: {
                id: this.instockId
              }
            })
          } else {
            this.$message({ message: '操作成功!', type: 'success' })
            this.$emit('update:xcVisible', false)
            this.Loading = false
            this.$parent.chaxun()
          }
        })
        .catch(error => {
          this.Loading = false
          this.$message({ message: error.message, type: 'error' })
        })
    },
    NumberInput (row) {
      row.weight = (row.number / 1 * row.singletonWeight).toFixed(4)
    },
    selectCangwei (row) {
      if (row.warehouseId != '') {
        row.warehouseName = this.warehouseOptions.filter(item => item.warehouseId == row.warehouseId)[0].warehouseName
      }
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({
      })
        .then((res) => {
          this.warehouseOptions = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 货物详情
    JfgetThreadDetailExpLists () {
      JfgetThreadDetailExpList({
        instockId: this.instockId
      })
        .then(res => {
          this.table = res
          this.table.forEach(item => {
            item.weight = (item.number / 1 * item.singletonWeight / 1).toFixed(4)
            getWeighingMethodList({
              productType: item.productType
            })
              .then(res => {
                if (res.length > 0) {
                  item.inWeighingMethod = res[0].inWeighingMethod
                  // inPoundMethod == 1  地磅   地磅磅重不可修改
                  // inPoundMethod == 2  吊磅
                  this.$set(item, 'inPoundMethod', res[0].inPoundMethod)
                  if (item.inPoundMethod == '1') {
                    this.$set(item, 'disWeighingWeight', true)
                  } else {
                    this.$set(item, 'disWeighingWeight', false)
                  }
                } else {
                  this.$message({ message: '计重方式未配置，请联系管理员', type: 'error' })
                }
              })
              .catch(err => {
                this.$message({ message: err.message, type: 'error' })
              })
          })
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  },
  mounted () {
    this.JfgetThreadDetailExpLists()
  },
  created () {
    this.zidianKuweiS()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        if (_this.confirmMark == true) {
          _this.confirmQueding()
        } else {
          _this.addDialog()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
